// import router from '@/main'
import { clearState, getState, setState, clearAccessToken, getAccessToken, setAccessToken, ACCESS_TOKEN_TYPE_INTERNAL,
    getValidateURL, ACCESS_TOKEN_TYPE_EXTERNAL, getTokenType, getStateCookie } from './auth-fn'
  import { HTTP } from './http-common'
  import { userStore } from './userstore'
  import { setAbilities } from './ability'
  import { appConfig } from '@/utils/config-api'
  import VueCookies from 'vue-cookies'
  
  export { getAPIRoot, authenticate, logout, checkAuthentication, checkChatAuthentication, refreshTokenInLiferay, 
    reAuthenticate, isAuthenticated, refreshAuthenticated, getCurrentUser, authenticateWithPassword, loginAsMontage, 
    loginAsMontageFromRequest }
  
  function getAPIRoot () {
    return `${window.location.protocol}//${window.location.hostname}:${window.location.port}${appConfig.backendUrl}`
  }
  
  function getAPIRootMain () {
    return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
  }
  
  function requestState (router, to) {
    let toCopy = Object.assign({}, to)
    console.log('requestState (savestate) Request state, to.path=' + toCopy.path)
    const a = document.createElement('a')
    a.href = router.resolve(toCopy).href
    console.log('requestState Request state, to.resolve=' + a.protocol + '//' + a.host + a.pathname + a.search + a.hash)
    const url = getAPIRoot() + '/auth/savestate'
    var apath = a.pathname + a.hash
    console.log('apath: ' + apath)
    if (apath.substring(0, 1) !== "/") {
      apath = '/' + apath
      console.log('apath after correction: ' + apath)
    }
    const params = {
      url: getAPIRootMain() + apath
    }
    return HTTP.get(url, {
      params
    }).then(
      response => {
        console.log('requestState Response, setting state=' + response.data.state)
        setState(response.data.state)
        return response.data.state
      }
    ).catch(error => {
      console.log('requestState catch error')
      console.log(error)
      clearState()
      clearAccessToken()
      throw error
    })
  }
  
  function requestTokenByState () {
    console.log('requestTokenByState Request state: ' + getState())
    const url = `/auth/getstate`
    const params = {
      state: getState()
    }
    return HTTP.get(url, {
      params
    }).then(
      response => {
        console.log('requestTokenByState Response token=' + response.data.accessToken)
        if (response.data.accessToken != null && response.data.accessToken.length > 0) {
          console.log('requestTokenByState setting access token')
          setAccessToken(response.data.accessToken, ACCESS_TOKEN_TYPE_INTERNAL)
          console.log('requestTokenByState - call getCurrentUser')
          getCurrentUser().then(
            uresponse => {
              console.log('getCurrentUser response: ')
              console.log(uresponse)
              if (uresponse.id) {
                userStore.state.id = uresponse.id
                userStore.state.userDomain = uresponse.userDomain
                userStore.state.fullName = uresponse.fullName
                userStore.state.roles = uresponse.roles
                userStore.state.authType = uresponse.authType
                userStore.state.loginName = uresponse.loginName
                userStore.state.phone = uresponse.phone
                console.log('requestTokenByState - setting abilities')
                setAbilities(uresponse)
              }
            }
          ).catch(error => {
            console.log('getCurrentUser catch error')
            console.log(error)
            clearAccessToken()
            throw error
          })
          return response.data.accessToken
        } else {
          console.log('requestTokenByState empty access token - throw error')
          return ''
        }
      }
    ).catch(error => {
      console.log('requestTokenByState catch error')
      console.log(error)
      clearState()
      clearAccessToken()
      throw error
    })
  }
  
  function refreshTokenInLiferay () {
    console.log('refreshTokenInLiferay, current token: ' + getAccessToken())
    const url = getValidateURL()
    const params = {
      token: getAccessToken()
    }
    console.log('refreshTokenInLiferay requesting URL:' + url + ', token: ' + getAccessToken())
    return HTTP.get(url, {
      params,
      baseURL: ''
    }).then(
      response => {
        console.log('refreshTokenInLiferay response: ' + response.data)
        if (response.data.token) {
          console.log('refreshTokenInLiferay response token: ' + response.data.token)
          setAccessToken(response.data.token, ACCESS_TOKEN_TYPE_EXTERNAL)
          return true
        } else {
          console.log('refreshTokenInLiferay Response error=' + response.data.error)
          return false
        }
      }
    ).catch(error => {
      console.log('refreshTokenInLiferay catch error')
      console.log(error)
      clearState()
      clearAccessToken()
      throw error
    })
  }
  
  function authenticateWithPassword (scope, login, password) {
    console.log('authenticateWithPassword start,  scope: ' + scope + ', login: ' + login)
    clearAccessToken()
    return new Promise((resolve, reject) => {
      const url = `/auth/autologin`
      const params = {
        state: getState(),
        scope: scope,
        username: login,
        password: password
      }
      return HTTP.post(url,
        JSON.stringify(params), {
          headers: {
            'content-type': 'application/json'
          }
        }).then(
          () => {
            resolve()
          }
        ).catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  
  function doPost(path, params, method='post') {
    console.log('doPost start ')
    //var tabWindowId = window.open('about:blank', 'wnd1')
    // _blank
    //var form = tabWindowId.document.createElement("form")
    //tabWindowId.document.body.appendChild(form)
    const form = document.createElement("form")
    form.method = method
    form.action = path
    form.target = "_self" // "_blank"
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = key
        hiddenField.value = params[key]
  
        form.appendChild(hiddenField)
      }
    }
    document.body.appendChild(form)
    form.submit()
  }
  
  function loginAsMontage (userId) {
    console.log('loginAsMontage start,  userId: ' + userId )
  
    return new Promise((resolve, reject) => {
      const url = `/auth/loginmontage`
      const params = {
        userId: userId,
        redirectUri: appConfig.montagePortalURL + 'montageadmin',
        scope: "montage",
        authToken: getAccessToken()
      }
      doPost(url, params)
    })
  }
  
  function loginAsMontageFromRequest() {
    console.log('loginAsMontageFromRequest start')
    clearState()
    clearAccessToken()
    var c = getStateCookie()
    console.log('State cookie from request: ' + c)
    setState(c)
    return new Promise((resolve, reject) => {
      requestTokenByState().then(() => {
        resolve()
      })
    })
  }
  
  function authenticatewithscope (router, to, scope) {
    console.log('authenticatewithscope start,  scope: ' + scope)
    clearState()
    clearAccessToken()
    return new Promise((resolve, reject) => {
      requestState(router, to).then(
        () => {
          console.log('authenticatewithscope - requestState redirecting to saas')
          let s = appConfig.authorizeURL +
            '?response_type=code&client_id=' + appConfig.clientId + '&redirect_uri=' +
            encodeURIComponent(appConfig.redirectURL) +
            '&scope=' + scope + '&state=' + getState()
          console.log('redirecting to: ' + s)
          window.location.href = s
        }
      ).catch(error => {
        console.log('requestState catch error')
        console.log(error)
        clearAccessToken()
        reject(error)
      })
    })
  }
  
  function authenticate (router, to) {
    return new Promise((resolve, reject) => {
      if (to.meta) {
        if (to.meta.requiredAuth) {
          console.log('authenticate start, to.path=' + to.path + ', scope: ' + to.meta.authType.scope)
          clearState()
          clearAccessToken()
          requestState(router, to).then(
            () => {
              console.log('authenticate - requestState redirecting to saas')
              let s = appConfig.authorizeURL +
                '?response_type=code&client_id=' + appConfig.clientId + '&redirect_uri=' +
                encodeURIComponent(appConfig.redirectURL) +
                '&scope=' + to.meta.authType.scope + '&state=' + getState()
              if (to.meta.authMethod) {
                s = s + '&method=' + to.meta.authMethod
              }
              console.log('redirecting to: ' + s)
              window.location.href = s
            }
          ).catch(error => {
            console.log('requestState catch error')
            console.log(error)
            clearAccessToken()
            reject(error)
          })
        } else {
          console.log('auth not required in meta')
          resolve(true)
        }
      } else {
        console.log('no meta in to')
        resolve(true)
      }
    })
  }
  
  function logout (newPath) {
    console.log('logout start')
    let token = getAccessToken()
    clearState()
    clearAccessToken()
    setAbilities(null)
    if (newPath) {
      if (newPath.indexOf('http') >= 0) {
        window.location.href = appConfig.logoutURL +
          '?client_id=' + appConfig.clientId + '&redirect_uri=' +
          encodeURIComponent(newPath) +
          '&state=logout&access_token=' + token
      } else {
        window.location.href = appConfig.logoutURL +
          '?client_id=' + appConfig.clientId + '&redirect_uri=' +
          encodeURIComponent(getAPIRootMain() + newPath) +
          '&state=logout&access_token=' + token
      }
    } else {
      window.location.href = appConfig.logoutURL +
        '?client_id=' + appConfig.clientId + '&redirect_uri=' +
        encodeURIComponent(getAPIRootMain()) +
        '&state=logout&access_token=' + token
    }
  }
  
  function reAuthenticate (router, to, error) {
    console.log('reAuthenticate start')
    console.log(error)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log('reAuthenticate 401')
      clearState()
      clearAccessToken()
      return checkAuthentication(router, to)
    } else if (error.Response && (error.Response.status === 401 || error.Response.status === 403)) {
        console.log('reAuthenticate 401')
        clearState()
        clearAccessToken()
        return checkAuthentication(router, to)
    } else {
      console.log('unhandled error: ')
      console.log(error)
      router.push('/error')
    }
  }
  
  function checkChatAuthentication (router, to, scope) {
    console.log('checkChatAuthentication1 ACCESS_TOKEN_TYPE_INTERNAL')
    if (!checkToken()) {
      console.log('checkChatAuthentication1 - no token present')
      if (checkState()) {
        console.log('checkChatAuthentication1 - state present: ' + getState())
        return requestTokenByState().then(
          response => {
            console.log('requestTokenByState1 success')
            if (!checkToken()) {
              console.log('requestTokenByState1 success, but null token returned')
              clearState()
              clearAccessToken()
              console.log('requestTokenByState1 call authenticate')
              return authenticatewithscope(router, to, scope).then(response => {
                console.log('requestTokenByState1 authenticate success, refreshing page')
                // router.push('')
                return false
              }).catch(error => {
                console.log(error)
                console.log('requestTokenByState1 authenticate error, redirecting to dead end')
                router.push('/noauth')
              })
            } else {
              // Token found - save state to cookie
              VueCookies.set("state", getState())
            }
            // router.push(to)
            return true
          }
        ).catch(
          error => {
            console.log('requestTokenByState catch error - clear state, gen new state')
            console.log(error)
            clearState()
            clearAccessToken()
            console.log('requestTokenByState call authenticate')
            authenticatewithscope(router, to, scope).then(response => {
              console.log('requestTokenByState authenticate success, refreshing page')
              router.push('')
            }).catch(error => {
              console.log(error)
              console.log('requestTokenByState authenticate error, redirecting to dead end')
              router.push('/noauth')
            })
            // return false
          }
        )
      // } else {
      //   console.log('checkAuthentication2 - no state present')
      //  return authenticate(router, to)
      } else {
        console.log('checkChatAuthentication2 - no token, no state - call authenticate')
        return authenticatewithscope(router, to, scope).then(response => {
          console.log('checkAuthentication authenticate success, refreshing page')
          // router.push('')
          return false
        }).catch(error => {
          console.log(error)
          console.log('checkChatAuthentication2 authenticate error, redirecting to dead end')
          router.push('/noauth')
          return false
        })
      }
      // let token = getAccessToken()
      // return !!token
    } else {
      console.log('checkChatAuthentication ok - token present')
      refreshAuthenticated()
      return Promise.resolve(true)
    }
  }
  
  
  function checkAuthentication (router, to) {
    return new Promise((resolve, reject) => {
      if (to.meta) {
        if (to.meta.requiredAuth) {
          if (getTokenType() === ACCESS_TOKEN_TYPE_EXTERNAL) {
            console.log('checkAuthentication ACCESS_TOKEN_TYPE_EXTERNAL')
            if (!checkToken()) {
              // No real token
              console.log('checkAuthentication - no token present')
              router.push('/noauth')
              return reject(false)
            } else {
              // Refresh token
              console.log('checkAuthentication token present')
              return refreshTokenInLiferay().then(
                response => {
                  console.log('requestTokenByState success - return true')
                  // router.push(to)
                  resolve(true)
                }
              ).catch(
                error => {
                  console.log('requestTokenByState catch error - clear state, gen new state')
                  console.log(error)
                  clearState()
                  clearAccessToken()
                  router.push('/noauth')
                  return reject(false)
                }
              )
            }
          } else {
            console.log('checkAuthentication1 ACCESS_TOKEN_TYPE_INTERNAL')
            if (!checkToken()) {
              console.log('checkAuthentication1 - no token present')
              if (checkState()) {
                console.log('checkAuthentication1 - state present: ' + getState())
                return requestTokenByState().then(
                  () => {
                    console.log('requestTokenByState1 success')
                    if (!checkToken()) {
                      console.log('requestTokenByState1 success, but null token returned')
                      clearState()
                      clearAccessToken()
                      console.log('requestTokenByState1 call authenticate')
                      return authenticate(router, to).then(() => {
                        console.log('requestTokenByState1 authenticate success, refreshing page')
                        // router.push('')
                        // return reject(false)
                      }).catch(error => {
                        console.log(error)
                        console.log('requestTokenByState1 authenticate error, redirecting to dead end')
                        router.push('/noauth')
                      })
                    } else {
                      // Token found - save state to cookie
                      VueCookies.set("state", getState())
                    }
                    // router.push(to)
                    resolve(true)
                  }
                ).catch(
                  error => {
                    console.log('requestTokenByState catch error - clear state, gen new state')
                    console.log(error)
                    clearState()
                    clearAccessToken()
                    console.log('requestTokenByState call authenticate')
                    authenticate(router, to).then(response => {
                      console.log('requestTokenByState authenticate success, refreshing page')
                      router.push('')
                    }).catch(error => {
                      console.log(error)
                      console.log('requestTokenByState authenticate error, redirecting to dead end')
                      router.push('/noauth')
                    })
                    // return false
                    return reject(false)
                  }
                )
              // } else {
              //   console.log('checkAuthentication2 - no state present')
              //  return authenticate(router, to)
              } else {
                console.log('checkAuthentication2 - no token, no state - call authenticate')
                authenticate(router, to).then(response => {
                  console.log('checkAuthentication authenticate success, refreshing page')
                  // router.push('')
                  return reject(false)
                }).catch(error => {
                  console.log(error)
                  console.log('checkAuthentication 2authenticate error, redirecting to dead end')
                  router.push('/noauth')
                  return reject(false)
                })
              }
              // let token = getAccessToken()
              // return !!token
            } else {
              console.log('checkAuthentication ok - token present')
              refreshAuthenticated().then(() => {
                console.log('refreshAuthenticated ok result received')
                resolve(true)
              }, err =>
                resolve(err)
              )
            }
          }
        } else {
          resolve(true)
        }
      } else {
        resolve(true)
      }
    })
  }
  
  function checkToken () {
    console.log('checkToken start')
    let token = getAccessToken()
    return !!token
  }
  
  function checkState () {
    console.log('checkState start')
    let state = getState()
    return !!state
  }
  
  function isAuthenticated () {
    console.log('isAuthenticated start')
    return checkToken() && !!userStore.state.id
  }
  
  function refreshAuthenticated () {
    console.log('refreshAuthenticated start')
    return new Promise((resolve, reject) => {
      if (checkToken() && !userStore.state.id) {
        console.log('refreshAuthenticated has token, but no user - getting from server')
        getCurrentUser().then(
          response => {
            console.log('getCurrentUser response: ')
            console.log(response)
            if (response.id) {
              userStore.state.id = response.id
              userStore.state.userDomain = response.userDomain
              userStore.state.fullName = response.fullName
              userStore.state.roles = response.roles
              userStore.state.authType = response.authType
              userStore.state.loginName = response.loginName
              userStore.state.phone = response.phone
              console.log('refreshAuthenticated - setting abilities')
              setAbilities(response)
            } else {
              console.log('getCurrentUser no response from server - very bad')
            }
            resolve(!!userStore.state.id)
          }
        ).catch(error => {
          console.log('getCurrentUser catch error')
          console.log(error)
          clearAccessToken()
          setAbilities(null)
          reject(error)
        })
      } else {
        resolve(!!userStore.state.id)
      }
    })
  }
  
  function getCurrentUser () {
    const url = `/worker/user/curuser`
    console.log('getCurrentUser start')
    return new Promise((resolve, reject) => {
      HTTP({
        method: 'get',
        url: url,
        headers: {
          credentials: 'same-origin',
          Authorization: `Bearer ${getAccessToken()}`,
          Accept: "*/*",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          Pragma: "no-cache"
        }
      }).then(response => {
        console.log('getCurrentUser response arrived')
        resolve(response.data)
      }).catch(error => {
        console.log('getCurrentUser error arrived')
        console.log(error)
        reject(error)
      })
    })
  }
  
  